import { useRouter } from "next/router";
import { Center, Pagination } from "@mantine/core";
import { useWindowScroll } from "@mantine/hooks";
import parsePageNr from "utils/parsePageNr";
import { NumberParam, useQueryParam } from "use-query-params";

const OverviewPagination = ({ isLoading, totalResults }) => {
  const [, scrollTo] = useWindowScroll();
  const router = useRouter();
  const [, setPage] = useQueryParam("page", NumberParam);

  const changePage = (page) => {
    scrollTo({ y: 0 });
    setPage(page);
  };

  return (
    <Center mt={20}>
      {!isLoading && (
        <Pagination
          page={parsePageNr(router.query.page) + 1}
          total={Math.round(totalResults / 20)}
          onChange={changePage}
        />
      )}
    </Center>
  );
};

export default OverviewPagination;
